import React, { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState(null);

  useEffect(() => {
    const consent = localStorage.getItem("location_consent");

    if (consent === "granted" && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          localStorage.setItem("user_location", JSON.stringify(coords));
          setLocation(coords);
        },
        (error) => {
          console.error("Location error:", error);
        }
      );
    } else {
      const saved = localStorage.getItem("user_location");
      if (saved) {
        setLocation(JSON.parse(saved));
      }
    }
  }, []);

  return (
    <LocationContext.Provider value={{ location, setLocation }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useUserLocation = () => useContext(LocationContext);